/* ==========================================================================
   VETMA — Page d'accueil
   Galerie du livre et bascule Magazine / Merch.
   ========================================================================== */

(function () {
  'use strict';

  /* ----------------------------------------------------------------------
     Galerie du livre : les miniatures changent l'image affichée
     ---------------------------------------------------------------------- */
  var book = document.querySelector('[data-book]');

  if (book) {
    var images = book.querySelectorAll('[data-book-img]');
    var thumbs = book.querySelectorAll('[data-book-thumb]');

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = thumb.dataset.bookThumb;

        images.forEach(function (img) {
          img.classList.toggle('is-active', img.dataset.bookImg === index);
        });
        thumbs.forEach(function (t) {
          t.classList.toggle('is-active', t === thumb);
        });
      });
    });
  }

  /* ----------------------------------------------------------------------
     Ajout au panier
     Demande au passage le HTML a jour des sections du panier, puis emet
     l'evenement que le theme ecoute pour rafraichir son tiroir.
     ---------------------------------------------------------------------- */
  var bookForm = document.querySelector('[data-book-form]') || document.querySelector('#v-home-book-form');

  if (bookForm) {
    var cta = bookForm.querySelector('[data-book-cta]');
    var ctaLabel = cta ? cta.querySelector('span') : null;
    var originalLabel = ctaLabel ? ctaLabel.innerHTML : '';
    var bookRoot = document.querySelector('[data-book]');

    /* Sections que le theme met a jour apres un ajout */
    var CART_SECTIONS = 'drawer-cart-items,drawer-cart-footer,cart-item-count,cart-live-region';

    /* Fait voler une copie de l'image vers l'icone du panier */
    function flyToCart() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var source = document.querySelector('.v-book__img.is-active');
      var target = document.querySelector('[href$="/cart"], [\\@click\\.prevent*="cart"]');
      if (!source) return;

      var from = source.getBoundingClientRect();
      /* Sans icone de panier reperable, on vise le coin haut droit */
      var to = target
        ? target.getBoundingClientRect()
        : { left: window.innerWidth - 70, top: 20, width: 40, height: 40 };

      var ghost = source.cloneNode();
      ghost.className = 'v-fly';
      ghost.style.left = from.left + 'px';
      ghost.style.top = from.top + 'px';
      ghost.style.width = from.width + 'px';
      ghost.style.height = from.height + 'px';
      document.body.appendChild(ghost);

      requestAnimationFrame(function () {
        ghost.style.left = (to.left + to.width / 2 - 24) + 'px';
        ghost.style.top = (to.top + to.height / 2 - 24) + 'px';
        ghost.style.width = '48px';
        ghost.style.height = '48px';
        ghost.style.opacity = '0.15';
        ghost.style.borderRadius = '50%';
      });

      setTimeout(function () { ghost.remove(); }, 900);
    }

    bookForm.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!cta || cta.disabled) return;

      var variantId = bookForm.querySelector('input[name="id"]').value;
      var items = [{ id: variantId, quantity: 1 }];

      /* Le cadeau part avec le produit ; la reduction Shopify le met a 0 EUR */
      var giftId = bookRoot ? bookRoot.dataset.giftVariant : null;

      cta.disabled = true;
      cta.classList.add('is-loading');
      flyToCart();

      /* La reduction Shopify n'offre qu'un cadeau par commande :
         on ne l'ajoute que s'il n'y est pas deja. */
      fetch(window.Shopify.routes.root + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var alreadyGifted = cart.items.some(function (line) {
            return line.properties && line.properties._gift;
          });

          if (giftId && !alreadyGifted) {
            items.push({
              id: giftId,
              quantity: 1,
              properties: { _gift: bookRoot.dataset.giftLabel || 'Free gift' }
            });
          }

          return fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items, sections: CART_SECTIONS })
          });
        })
        .then(function (r) {
          return r.json().then(function (data) {
            /* Shopify repond 422 si un article ne peut pas etre ajoute */
            if (!r.ok) {
              var msg = data.description || data.message || 'ajout refuse';
              throw new Error(msg);
            }
            return data;
          });
        })
        .then(function (response) {
          cta.classList.remove('is-loading');
          cta.classList.add('is-done');
          if (ctaLabel && bookRoot) {
            ctaLabel.innerHTML = bookRoot.dataset.addedLabel || 'Added to cart';
          }

          /* Le theme redessine son tiroir a partir de ces sections */
          window.dispatchEvent(
            new CustomEvent('switch:cart:afteradditem', {
              detail: { response: response }
            })
          );
          document.body.dispatchEvent(
            new CustomEvent('switch:cart:afteradditem', { bubbles: true })
          );

          setTimeout(function () {
            if (window.Alpine && Alpine.store && Alpine.store('modals')) {
              Alpine.store('modals').open('cart');
            }
            cta.classList.remove('is-done');
            cta.disabled = false;
            if (ctaLabel) ctaLabel.innerHTML = originalLabel;
          }, 800);
        })
        .catch(function (err) {
          if (window.console) console.warn('[Vetma] panier :', err.message);
          cta.classList.remove('is-loading');
          cta.disabled = false;

          /* Le cadeau a echoue : on ajoute au moins le produit */
          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: bookForm.querySelector('input[name="id"]').value, quantity: 1 }],
              sections: CART_SECTIONS
            })
          })
            .then(function (r) { return r.json(); })
            .then(function (response) {
              window.dispatchEvent(new CustomEvent('switch:cart:afteradditem', {
                detail: { response: response }
              }));
              if (window.Alpine && Alpine.store && Alpine.store('modals')) {
                Alpine.store('modals').open('cart');
              }
            });
        });
    });
  }

  /* ----------------------------------------------------------------------
     Pop-up : suivi de production
     ---------------------------------------------------------------------- */
  var modal = document.querySelector('[data-tracker]');

  if (modal) {
    var lastFocus = null;

    function openTracker() {
      lastFocus = document.activeElement;
      modal.hidden = false;
      requestAnimationFrame(function () { modal.classList.add('is-open'); });
      document.body.style.overflow = 'hidden';
      var closeBtn = modal.querySelector('[data-tracker-close]');
      if (closeBtn) closeBtn.focus();
    }

    function closeTracker() {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(function () { modal.hidden = true; }, 300);
      if (lastFocus) lastFocus.focus();
    }

    document.querySelectorAll('[data-open-tracker]').forEach(function (trigger) {
      trigger.addEventListener('click', openTracker);
      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openTracker(); }
      });
    });

    modal.querySelectorAll('[data-tracker-close]').forEach(function (btn) {
      btn.addEventListener('click', closeTracker);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeTracker();
    });
  }

  /* ----------------------------------------------------------------------
     Bascule Magazine / Merch
     ---------------------------------------------------------------------- */
  var switcher = document.querySelector('[data-switch]');

  if (switcher) {
    switcher.querySelectorAll('[data-switch-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.dataset.switchTab;

        switcher.querySelectorAll('[data-switch-tab]').forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });

        switcher.querySelectorAll('[data-switch-panel]').forEach(function (panel) {
          panel.classList.toggle('is-active', panel.dataset.switchPanel === target);
        });
      });
    });
  }
})();
